module.exports = __webpack_public_path__ + "static/media/big_unicorn.02ff316b.png";